/* unplugin-vue-components disabled */import { render } from "./CPageHeader.vue?vue&type=template&id=9ed1a30a&ts=true"
import script from "./CPageHeader.vue?vue&type=script&lang=ts"
export * from "./CPageHeader.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__